exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{word-break:keep-all}#content-breadcrumbs .v-toolbar__content{height:30px!important}#content-breadcrumbs .v-breadcrumbs{padding:0!important}#inner-content{overflow:hidden}@media (min-width:1904px){#inner-content{max-width:1185px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c50d25e0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/Content.vue
// module id = 464
// module chunks = 0